// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"Buttons_genericButton__1FVcd","primaryButton":"Buttons_primaryButton__F0qwS","secondaryButton":"Buttons_secondaryButton__ONMAh","arrow":"Buttons_arrow__FYbFj"};